import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../../../../services/contact-us.service';

type ContactLink = {
  label: string;
  value: string;
  url: string;
  icon?: string;
  fallbackIcon?: string;
  external?: boolean;
};

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent implements OnInit {
  Data!: FormGroup;

  isSubmitting = false;
  submitSuccess = false;

  contactLinks: ContactLink[] = [
    {
      label: 'Email',
      value: 'blueboxegp@gmail.com',
      url: 'mailto:blueboxegp@gmail.com',
      fallbackIcon: '✉️',
      external: false,
    },
    {
      label: 'WhatsApp',
      value: '+20 11 49444701',
      url: 'https://wa.me/201149444701',
      fallbackIcon: '💬',
      external: true,
    },
    {
      label: 'Phone',
      value: '011 49444701',
      url: 'tel:+201149444701',
      fallbackIcon: '📞',
      external: false,
    },
    {
      label: 'Facebook',
      value: 'facebook.com/blueboxmart',
      url: 'https://www.facebook.com/blueboxmart',
      icon: '/assets/logos_facebook.png',
      external: true,
    },
    {
      label: 'Instagram',
      value: 'instagram.com/blueboxmart',
      url: 'https://www.instagram.com/blueboxmart',
      icon: '/assets/skill-icons_instagram.png',
      external: true,
    },
    {
      label: 'TikTok',
      value: 'tiktok.com/@blueboxmart',
      url: 'https://www.tiktok.com/@blueboxmart',
      fallbackIcon: '♪',
      external: true,
    },
    {
      label: 'YouTube',
      value: 'youtube.com/@blueboxmart',
      url: 'https://www.youtube.com/@blueboxmart',
      fallbackIcon: '▶️',
      external: true,
    },
  ];

  constructor(
    private _formBuilder: FormBuilder,
    private _contactUsService: ContactUsService
  ) {}

  ngOnInit(): void {
    this.initiate();
  }

  initiate(): void {
    this.Data = this._formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required, Validators.minLength(5)]],
    });
  }

  onSubmit(): void {
    this.submitSuccess = false;

    if (this.Data.invalid) {
      this.Data.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    this._contactUsService.addMessage(this.Data.value).subscribe({
      next: (res) => {
        console.log(res);

        this.isSubmitting = false;
        this.submitSuccess = true;
        this.Data.reset();
      },
      error: (err) => {
        console.log(err);

        this.isSubmitting = false;
      },
    });
  }
}